import { render } from "./emailConfiguration.vue?vue&type=template&id=57932879"
import script from "./emailConfiguration.vue?vue&type=script&lang=js"
export * from "./emailConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__